import { render, staticRenderFns } from "./TenantRadioGroup.vue?vue&type=template&id=5d9571a0&scoped=true&"
import script from "./TenantRadioGroup.vue?vue&type=script&lang=js&"
export * from "./TenantRadioGroup.vue?vue&type=script&lang=js&"
import style0 from "./TenantRadioGroup.vue?vue&type=style&index=0&id=5d9571a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9571a0",
  null
  
)

/* custom blocks */
import block0 from "./TenantRadioGroup.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports